module.exports = __webpack_public_path__ + "img/home_p4_icon3.eb7b3909.png";